// Google Sheets API utility for storing email subscriptions

/**
 * Sends email subscription data to Google Sheets via Google Forms
 * @param {string} email - The subscriber's email address
 * @returns {Promise<boolean>} - Success status
 */
export const saveEmailToGoogleSheets = async (email) => {
  try {
    console.log('Attempting to save email:', email);
    
    // Validate email format first
    if (!validateEmail(email)) {
      console.error('Invalid email format');
      return false;
    }
    
    // Use the environment variable for the Google Apps Script URL
    const GOOGLE_APPS_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SHEETS_URL;
    
    if (!GOOGLE_APPS_SCRIPT_URL || GOOGLE_APPS_SCRIPT_URL === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE' || GOOGLE_APPS_SCRIPT_URL.includes('YOUR_SCRIPT_ID')) {
      console.warn('Google Apps Script URL not configured properly. Please update REACT_APP_GOOGLE_SHEETS_URL in your .env file');
      return false;
    }
    
    console.log('Using URL:', GOOGLE_APPS_SCRIPT_URL);
    
    // Use GET request with query parameters to avoid POST body issues with no-cors
    const params = new URLSearchParams({
      email: email,
      timestamp: new Date().toISOString(),
      source: 'bervin-website',
      action: 'subscribe'
    });
    
    const fullUrl = `${GOOGLE_APPS_SCRIPT_URL}?${params.toString()}`;
    console.log('Full URL with params:', fullUrl);
    
    // Use no-cors mode to bypass CORS preflight
    // const response = await fetch(fullUrl, {
    await fetch(fullUrl, {
      method: 'GET',
      mode: 'no-cors', // This bypasses CORS but we won't get response data
    });
    
    // With no-cors mode, we can't check the response, so we'll assume success
    console.log('GET request sent with no-cors mode');
    
    // Since we can't verify the response with no-cors, 
    // we'll return true and hope it worked
    return true;
    
  } catch (error) {
    console.error('Error saving email to Google Sheets:', error);
    return false;
  }
};

/**
 * Alternative method using a hidden form submission
 * @param {string} email - The subscriber's email address
 * @returns {Promise<boolean>} - Success status
 */
export const saveEmailViaForm = async (email) => {
  try {
    // Create a hidden iframe and form to submit to Google Forms
    // This completely bypasses CORS issues
    
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.name = 'hiddenFrame';
    document.body.appendChild(iframe);
    
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://docs.google.com/forms/d/e/YOUR_FORM_ID/formResponse';
    form.target = 'hiddenFrame';
    
    const emailInput = document.createElement('input');
    emailInput.type = 'hidden';
    emailInput.name = 'entry.YOUR_ENTRY_ID'; // You'll need to get this from form inspection
    emailInput.value = email;
    
    form.appendChild(emailInput);
    document.body.appendChild(form);
    
    // Submit the form
    form.submit();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(form);
      document.body.removeChild(iframe);
    }, 1000);
    
    return true;
    
  } catch (error) {
    console.error('Error with form submission:', error);
    return false;
  }
};

/**
 * Validates email format
 * @param {string} email - Email to validate
 * @returns {boolean} - Whether email is valid
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
